module.exports = "<label class=\"w-50\">{{registro.fecha | date : 'short'}}</label>\n<label class=\"w-50\">{{registro.valor}} {{registro.unidad}}</label>"